import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionSelectionChange, provideNativeDateAdapter} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {RouterLink} from "@angular/router";
import {AccountModel} from "../../domain/models/account.model";
import {MatCardModule} from "@angular/material/card";
import {InactivatePropertyService} from "../../domain/services/property/inactivate-property.service";
import {LookupsServiceService} from "../../domain/services/lookups/lookups-service.service";
import {PropertyDialogService} from "../../domain/services/dialog/property-dialog.service";

@Component({
  selector: 'app-inactivate-property-info',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, MatIconModule, CommonModule, ReactiveFormsModule, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, MatInputModule, RouterLink, MatCardModule,],
  templateUrl: './inactivate-property-info.component.html',
  styleUrl: './inactivate-property-info.component.css',
  providers: [provideNativeDateAdapter()],
})
export class InactivatePropertyInfoComponent implements OnInit, OnChanges {
  @Input() account: AccountModel | undefined;
  reasons: string[] = [];
  inactivateForm: FormGroup | undefined;

  constructor(private fb: FormBuilder, private readonly dialogService: PropertyDialogService, private readonly inactivateService: InactivatePropertyService, private readonly lookups: LookupsServiceService) {
  }

  ngOnInit() {
    this.buildForm();
    this.pullReasons();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['account']) {
      this.pullReasons();
      this.pullLastInactivation();
    }
  }

  buildForm() {
    this.inactivateForm = this.fb.group({
      contractFile: [null, Validators.required],
      reason: ['', Validators.required],
      lastRented: ['', Validators.required],
      comments: [''],
    });
  }

  pullReasons() {
    if (!this.account) return;
    this.lookups.getInactivateReasons().subscribe(reasons => {
      this.reasons = reasons.filter(r => r.type === this.account?.type)
        .map(reason => reason.reasons ?? '');
    })
  }

  pullLastInactivation() {
    if (!this.account) return;
    const rentalId = this.account?.rentalProperty?.id;
    if (!rentalId) return;
    this.inactivateService.getLastInactivation(rentalId).subscribe(lastInactivation => {
      this.inactivateForm?.get('lastRented')?.setValue(lastInactivation?.lastRented);
      this.inactivateForm?.get('reason')?.setValue(lastInactivation?.reason);
      this.inactivateForm?.get('comments')?.setValue(lastInactivation?.comments);
    });
  }

  reasonChanged(reason: MatOptionSelectionChange<string>) {
    //reason.source.value
  }

  openPropertyDetailModal() {
    if (!this.account) return;
    this.dialogService.openPropertyDialog(this.account, () => {

    });
  }

}
